const SoundbiteSentiment = Object.freeze({
  MIXED: 'Mixed',
  POSITIVE: 'Positive',
  NEGATIVE: 'Negative',
  NEUTRAL: 'Neutral',
  NONE: 'None'
})
export default SoundbiteSentiment
export type SoundbiteSentimentStrings = typeof SoundbiteSentiment[keyof typeof SoundbiteSentiment]
// RESERVE BELOW
